export const HOME_PAGE = "/";
export const DASHBOARD_PAGE = "/dashboard";
export const ACTIVITIES_PAGE = "/activities";
export const ACTIVITY_DETAIL_PAGE = "/activities/:activityId";
export const SETTINGS_PAGE = "/settings";
export const CONNECT_STRAVA_PAGE = "/signup";
export const PROFILE_PAGE = "/profile";
export const STRAVA_LOGIN_CALLBACK_PAGE = "/authentication/strava/login-callback";
export const LOGIN_CALLBACK_PAGE = "/authentication/login-callback";
export const NOT_FOUND_PAGE = "*";
